import { dispatch } from './store';
var install = function (Vue) {
    Vue.dispatch = dispatch;
};
export default install;
